import React from 'react'

const Info = function info ({text}){
    return (
        <main>
            <div className="back flex w90">
                <a href={https} className="flex">
                <img src={https+"img/back.svg"} alt="⬅"/>
                <span>Atrás</span>
                </a>
            </div>

            <section className="colflex emptyCart w90">
                <img src={https+"img/map.svg"} alt=""/>
                <h2>{text.title}</h2>
                <p>{text.text}</p>
                <a href={https+"shop"}>Ir a la tienda</a>
            </section>
        </main>
)
}

export default Info
